import React  from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import $ from "jquery";

import ThreeDWorkspace from "./components/ar3d/threeD/ThreeDWorkspace";
import SqftCanvasContainer from "./components/canvas/core/SqftCanvasContainer";
import ARWorkspaceSeparateModels from "./components/ar3d/ar/ARWorkspaceSeparateModels";
import { SQFT_VIEW_MODE } from "./constants";

import useImportSQFTData from "./hocs/onLoad/useImportSQFTData";
import useUpdateEditedFeatures from "./hocs/onLoad/useUpdateEditedFeatures";
import useUpdateShapesIntersections from "./hocs/onLoad/useUpdateIntersections";

import useWorkspaceIntl from "./hocs/onLoad/useWorkspaceIntl";
import useSqftTutorial from "./hocs/onLoad/useSqftTutorial";
import useSqftWorkspaceModeTransition from "./hocs/useSqftWorkspaceModeTransition";
import {prepareSQFTDataCore} from "./components/canvas/core/workspace/workspaceDataMapper";
import workspace from "./components/canvas/core/workspace";
import scale from "./components/canvas/core/controls/scale";
import sqftEventManager from "./components/canvas/store/sqftEventManager";

const SquareFootageToolViewWorkspace = (props) => {
  const {
    SQFTViewMode,
    visualizersLoaded,
    intl,
    sqftVisited,
    quotes,
    activeQuoteIndex,
    fabricatorData,
  } = props;

  useImportSQFTData(visualizersLoaded, SQFTViewMode);
  useUpdateShapesIntersections(visualizersLoaded);
  useUpdateEditedFeatures();
  useWorkspaceIntl(intl);
  useSqftTutorial({
    visualizersLoaded,
    sqftVisited,
    quotes,
    activeQuoteIndex,
    fabricatorData,
  });

  useSqftWorkspaceModeTransition({
    SQFTViewMode,
    onEnter2D: () => {
      sqftEventManager.clearAll();

      workspace.init($('#workspace'));
      scale.init();

      const coreData = prepareSQFTDataCore();
      workspace.import(coreData);
    },
  });

  switch (SQFTViewMode) {
    case SQFT_VIEW_MODE.threeDMode:
    case SQFT_VIEW_MODE.threeDModeFrameless:
      return <ThreeDWorkspace />;
    case SQFT_VIEW_MODE.threeDModeDoors:
      return <ThreeDWorkspace displayDoorsOnly={true} />;
    case SQFT_VIEW_MODE.threeDModeFramed:
      return <ThreeDWorkspace shouldDisplayFramedDoors={true} />;
    case SQFT_VIEW_MODE.augmentedReality:
    case SQFT_VIEW_MODE.augmentedRealityCabinet:
      return <ARWorkspaceSeparateModels />;
    case SQFT_VIEW_MODE.augmentedRealityDoorsOnly:
      return <ARWorkspaceSeparateModels displayDoorsOnly={true} />;
    case SQFT_VIEW_MODE.twoDMode:
    default:
      return <SqftCanvasContainer />;
  }
};

const mapStateToProps = (store) => ({
  SQFTViewMode: store.sqftState.SQFTViewMode,
  visualizersLoaded: store.serverState.visualizersLoaded,
  sqftVisited: store.sqftState.sqftFeaturesPopup.visited,
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  fabricatorData: store.fabricatorState,
});

export default injectIntl(connect(mapStateToProps)(SquareFootageToolViewWorkspace));
